import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="py-4 mt-auto finr">
      <div className="container text-center">
        <div className="mb-2">
          <Link className="mx-2 text-decoration-none" to="/privacy">
            Privacy Policy
          </Link>
          |
          <Link className="mx-2 text-decoration-none" to="/terms">
            Terms & Conditions
          </Link>
        </div>
        <div className="text-muted">
          &copy; {new Date().getFullYear()} ticktickgo.in. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
